import { isClientSide } from 'web/utils/ssr';

const isLocalDevelopmentHost =
  isClientSide &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname.endsWith('.localhost') ||
    window.location.hostname === '127.0.0.1');

const shouldUseEmulators =
  isLocalDevelopmentHost ||
  (!isClientSide && (process.env?.['FUNCTIONS_EMULATOR'] === 'true' || process.env?.['INTROWISE_WEB_ENV'] === 'local'));

export { shouldUseEmulators };
